import { render } from "./AufgabenView.vue?vue&type=template&id=faa0fd68"
import script from "./AufgabenView.vue?vue&type=script&lang=js"
export * from "./AufgabenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__